"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountMenu = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var react_2 = require("@chakra-ui/react");
var useHeaderProps_1 = require("../hooks/useHeaderProps");
var useIsMobile_1 = require("../hooks/useIsMobile");
var HeaderButton_1 = require("./HeaderButton");
var DropdownOption_1 = require("./_shared/DropdownOption");
var useMenuControls_1 = require("../hooks/useMenuControls");
var NotificationsMenu_1 = require("./NotificationsMenu");
var SearchBar_1 = require("./Search/SearchBar");
var TranslationsDropdown_1 = require("./TranslationsDropdown");
var colors_1 = require("../colors");
var NavLink_1 = require("./_shared/NavLink");
var HeaderLink_1 = require("./_shared/HeaderLink");
var NavMenu_1 = require("./_shared/NavMenu");
var UserProfileLink_1 = require("./UserProfileLink");
var AccountMenu = function (_a) {
    var withNotifications = _a.withNotifications, withTranslations = _a.withTranslations, children = _a.children, initialFocusOnSearchBar = _a.initialFocusOnSearchBar, onResourceCenterSelected = _a.onResourceCenterSelected;
    var _b = (0, useHeaderProps_1.useHeaderProps)(), user = _b.user, permissions = _b.permissions, siteConfiguration = _b.siteConfiguration, _js = _b._js;
    var _c = (0, react_2.useDisclosure)(), isOpen = _c.isOpen, onOpen = _c.onOpen, onClose = _c.onClose;
    var initialRef = (0, react_1.useRef)(null);
    var isMobile = (0, useIsMobile_1.useIsMobile)();
    var headerButtonStyles = {
        p: 0,
        borderRadius: 25,
        _hover: {
            opacity: 0.75,
        },
        _active: {
            opacity: 0.75,
        },
    };
    var links = (function () {
        var result = [];
        result.push({
            href: "/User/".concat(user === null || user === void 0 ? void 0 : user.userid, "/").concat(user === null || user === void 0 ? void 0 : user.username),
            className: 'header-link__view-profile',
            dataFeatureId: 'header_link_view_profile',
            content: _js('View Profile'),
        });
        if (siteConfiguration &&
            (siteConfiguration['feature-answers'] || siteConfiguration['feature-public-editing'])) {
            result.push({
                href: "/User/Graph/".concat(user === null || user === void 0 ? void 0 : user.userid, "/").concat(user === null || user === void 0 ? void 0 : user.username),
                className: 'header-link__reputation',
                dataFeatureId: 'header_link_reputation',
                content: (React.createElement(react_2.Text, { p: 0, mt: 0, mb: 0 },
                    React.createElement(react_2.chakra.span, { color: "yellow.600", fontWeight: "bold" }, reputationFormatter(user === null || user === void 0 ? void 0 : user.reputation)),
                    ' ',
                    _js('Reputation'))),
            });
        }
        if (siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['feature-approvals']) {
            result.push({
                href: '/User/approvals?status=pending',
                className: 'header-link__approval-requests',
                dataFeatureId: 'header_link_approval_requests',
                content: _js('Approval Requests'),
            });
        }
        if (siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['feature-zendesk-support-link']) {
            result.push({
                href: '/zendesk/launch',
                className: 'header-link__knowledge-base',
                dataFeatureId: 'header_link_knowledge_base',
                _target: '_blank',
                _rel: 'noopener noreferrer',
                content: _js('Support Center'),
            });
        }
        else if (permissions === null || permissions === void 0 ? void 0 : permissions.canIViewProductRoadmap) {
            result.push({
                href: siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['product-roadmap-url'],
                className: 'header-link__roadmap',
                dataFeatureId: 'header_link_roadmap',
                content: _js('Roadmap'),
            });
        }
        if ((siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['feature-pendo-resource-center']) && onResourceCenterSelected) {
            result.push({
                href: '',
                onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    onResourceCenterSelected();
                },
                className: 'header-link__resource-center',
                dataFeatureId: 'header_link_resource_center',
                content: _js('Resources'),
            });
        }
        if (user === null || user === void 0 ? void 0 : user.userid) {
            result.push({
                href: '/Logout',
                className: 'header-link__logout',
                dataFeatureId: 'header_link_logout',
                content: _js('Logout'),
            });
        }
        else {
            result.push({
                href: '/Login',
                className: 'header-link__login',
                dataFeatureId: 'header_link_login',
                content: _js('Login'),
            });
        }
        return result;
    })();
    if (!user && !isMobile) {
        return (React.createElement(HeaderLink_1.HeaderLink, { href: "/Login", className: "header-link__login", "data-feature-id": "header_link_login" }, _js('Login')));
    }
    return isMobile ? (React.createElement(React.Fragment, null,
        React.createElement(HeaderButton_1.HeaderButton, __assign({}, headerButtonStyles, { className: "header-user-toggle", "data-feature-id": "header_user_toogle", onClick: onOpen }), children),
        React.createElement(useMenuControls_1.MenuControlsContext.Provider, { value: { onOpen: onOpen, onClose: onClose } },
            React.createElement(react_2.Modal, { isOpen: isOpen, onClose: onClose, size: "full", initialFocusRef: initialRef },
                React.createElement(react_2.ModalContent, { bg: colors_1.DEFAULT_BACKGROUND_COLOR },
                    React.createElement(react_2.ModalHeader, { color: colors_1.DEFAULT_TEXT_COLOR }, _js('Account')),
                    React.createElement(react_2.ModalCloseButton, { color: colors_1.DEFAULT_TEXT_COLOR, mr: 1 }),
                    React.createElement(react_2.ModalBody, null,
                        React.createElement(react_2.VStack, { alignItems: "stretch", spacing: 0, color: colors_1.DEFAULT_TEXT_COLOR },
                            React.createElement(SearchBar_1.SearchBar, __assign({ mb: 2, color: colors_1.DEFAULT_TEXT_COLOR }, {
                                searchInputRef: initialFocusOnSearchBar ? initialRef : undefined,
                            })),
                            withTranslations && React.createElement(TranslationsDropdown_1.TranslationsDropdown, { displayMode: "accordion" }),
                            withNotifications && React.createElement(NotificationsMenu_1.NotificationsMenu, { displayMode: "accordion" }),
                            links.map(function (_a) {
                                var content = _a.content, props = __rest(_a, ["content"]);
                                if (props.href) {
                                    if (props.href === '') {
                                        return (React.createElement(react_2.Button, { paddingInlineStart: 0, pl: 2, h: 50, style: { justifyContent: 'flex-start' }, variant: "ghost", key: props.dataFeatureId, onClick: props.onClick, borderRadius: 0, fontWeight: "normal", _hover: { backgroundColor: 'gray.300' } }, content));
                                    }
                                    else {
                                        var subsetProps = __assign({}, props);
                                        return (React.createElement(NavLink_1.NavLink, __assign({}, subsetProps, { key: props.dataFeatureId, "data-feature-id": props.dataFeatureId }), content));
                                    }
                                }
                                return null;
                            })))))))) : (React.createElement(NavMenu_1.NavMenu, null,
        React.createElement(react_2.MenuButton, __assign({}, headerButtonStyles, { as: HeaderButton_1.HeaderButton, className: "header-user-toggle", "data-feature-id": "header_user_toogle" }), children),
        React.createElement(react_2.Portal, null,
            React.createElement(NavMenu_1.NavMenuList, { zIndex: 300, p: 0, m: 0, minWidth: "245px" }, links.map(function (link) {
                if (link.href === '') {
                    return (React.createElement(react_2.MenuItem, { p: 0, onClick: link.onClick, key: link.dataFeatureId },
                        React.createElement(react_2.Button, { variant: "ghost", style: { justifyContent: 'flex-start' }, className: link.className, "data-feature-id": link.dataFeatureId, fontWeight: "normal", borderRadius: 0, pl: 6, w: "100%", h: "53px" }, link.content)));
                }
                else if (link.dataFeatureId === 'header_link_view_profile') {
                    var subsetProps = __assign({}, link);
                    return (React.createElement(UserProfileLink_1.UserProfileLink, __assign({}, subsetProps, { title: link.content, key: link.dataFeatureId })));
                }
                else {
                    return (React.createElement(DropdownOption_1.DropdownOption, { pl: 2, key: link.dataFeatureId, href: link.href, className: link.className, "data-feature-id": link.dataFeatureId }, link.content));
                }
            })))));
};
exports.AccountMenu = AccountMenu;
var reputationFormatter = function (num) {
    if (num === undefined)
        return null;
    if (num > 999 && num < 1000000) {
        return parseFloat((num / 1000).toFixed(1)).toString() + 'k';
    }
    else if (num > 1000000) {
        return parseFloat((num / 1000000).toFixed(1)).toString() + 'm';
    }
    else {
        return num.toString();
    }
};
